module.exports = __webpack_public_path__ + "img/goods11_3.be6d9680.jpg";